<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.14334 26.4127H54.8576V30.4762H9.14334V26.4127Z" fill="#05070F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5376 48.8252H58.9211C60.0432 48.8252 60.9529 47.9156 60.9529 46.7935V11.1746C60.9529 10.0525 60.0432 9.14283 58.9211 9.14283H6.09572C4.97362 9.14283 4.06397 10.0525 4.06397 11.1746V46.7935C4.06397 47.9156 4.97362 48.8252 6.09572 48.8252H12.0956L12.0956 57.0027L22.5376 48.8252ZM23.2385 50.857H58.9211C61.1653 50.857 62.9846 49.0377 62.9846 46.7935V11.1746C62.9846 8.93037 61.1653 7.11108 58.9211 7.11108H6.09572C3.85151 7.11108 2.03223 8.93037 2.03223 11.1746V46.7935C2.03223 49.0377 3.85151 50.857 6.09572 50.857H10.0638V57.0027C10.0638 58.6965 12.0147 59.6467 13.3483 58.6023L23.2385 50.857Z"
      fill="#05070F"
    />
    <path d="M9.14258 34.5397H47.7458V36.5714H9.14258V34.5397Z" fill="#05070F" />
    <path d="M9.14258 38.6032H41.6505V40.6349H9.14258V38.6032Z" fill="#05070F" />
    <path
      d="M13.2061 20.7439L10.6878 22.3492L11.3556 19.3392L9.14258 17.3125L12.0614 17.0516L13.2061 14.2222L14.3507 17.0516L17.2696 17.3125L15.0566 19.3392L15.7243 22.3492L13.2061 20.7439Z"
      fill="#FF0064"
    />
    <path
      d="M22.3496 20.7439L19.8314 22.3492L20.4991 19.3392L18.2861 17.3125L21.205 17.0516L22.3496 14.2222L23.4943 17.0516L26.4131 17.3125L24.2001 19.3392L24.8678 22.3492L22.3496 20.7439Z"
      fill="#FF0064"
    />
    <path
      d="M31.4922 20.7439L28.974 22.3492L29.6417 19.3392L27.4287 17.3125L30.3476 17.0516L31.4922 14.2222L32.6368 17.0516L35.5557 17.3125L33.3427 19.3392L34.0104 22.3492L31.4922 20.7439Z"
      fill="#FF0064"
    />
    <path
      d="M40.6348 20.7439L38.1166 22.3492L38.7843 19.3392L36.5713 17.3125L39.4901 17.0516L40.6348 14.2222L41.7794 17.0516L44.6983 17.3125L42.4853 19.3392L43.153 22.3492L40.6348 20.7439Z"
      fill="#FF0064"
    />
    <path
      d="M49.7774 20.7439L47.2591 22.3492L47.9268 19.3392L45.7139 17.3125L48.6327 17.0516L49.7774 14.2222L50.922 17.0516L53.8409 17.3125L51.6279 19.3392L52.2956 22.3492L49.7774 20.7439Z"
      fill="#FF0064"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'RequestReviewsIllustration',
  props: {
    width: {
      type: Number,
      default: 64,
    },
    height: {
      type: Number,
      default: 64,
    },
  },
};
</script>
